import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { pagingDefaultSettings } from '../../../shared/directives/sortable-table-header.directive';
import { NbDialogService } from '@nebular/theme';
import { ChannelMappingService, LoadingOverlayService, ToasterService, FracproChannelsService, FracproChannelStorageService } from '../../../shared/services';
import { Helper } from '../../../shared/helpers/helper';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { FracproChannelsFormModalComponent } from './fracpro-channels-form-modal.component';
import { isEmpty } from 'lodash';

@Component({
  selector: 'app-fracpro-channels',
  templateUrl: './fracpro-channels.component.html',
  styleUrls: ['./fracpro-channels.component.scss']
})
export class FracproChannelsComponent implements OnInit {
  curCompanyId: number;
  subscriptions: Subscription[] = [];
  formAdding: FormGroup;
  diagnosticName: AbstractControl;

  pageState = {
    submitting: false,
    loading: false,
    isShowCompanySelector: false,
    currentCompanyId: 0,
  };

  pagingState = { ...pagingDefaultSettings };

  @Input() dataSource = [];
  @Input()
  set companyId(id: number) {
    if (this.curCompanyId !== id) {
      this.curCompanyId = id;
      // load data by company
      console.log(id);
      this.loadDataTable();
    }
  }

  constructor(
    private nbDialogService: NbDialogService,
    private fracproChannelsService: FracproChannelsService,
    private fb: FormBuilder,
    private loadingOverlayService: LoadingOverlayService,
    private toasterService: ToasterService,
    private fracproChannelStorageService: FracproChannelStorageService
  ) { }

  get dataTable(): any[] {
    const result = this.dataSource.slice(
      (this.pagingState.page - 1) * this.pagingState.pageSize,
      (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
    );
    return result;
  }

  ngOnInit(): void {
    // this.pageState.loading = true;
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  loadDataTable() {
    this.pageState.loading = true;
    this.subscriptions.push(
      this.fracproChannelsService.getLatestVersion().subscribe(res => {
        let data = [];
        if (res && res.result) {
          data = res.result;
          this.dataSource = data;
          this.pagingState.collectionSize = this.dataSource.length;
          this.fracproChannelStorageService.setFracproChannels(data);
        }
        this.pageState.loading = false;
      }, err => {
        this.pageState.loading = false;
      })
    );
  }

  showEdit(event, item, index) {
    this.nbDialogService.open(FracproChannelsFormModalComponent, {
      autoFocus: false,
      context: {
        selectedItem: { ...item },
        indexItem: index,
        listChannels: [...this.dataSource]
      }
    })
      .onClose.subscribe(data => {
        if (data) {
          this.loadDataTable();
        }
      });
  }

  resetColor() {
    console.log(this.dataSource);
    if (!isEmpty(this.dataSource)) {
      const payload = {
        channels: this.dataSource.map(item => {
          item.color = item.defaultColor;
          return item;
        })
      };
      this.subscriptions.push(
        this.fracproChannelsService.update(payload).subscribe(res => {
          this.loadDataTable();
        })
      );
    }
  }

}
